import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 48,
    width: '100%',
    minHeight: 250,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 16,
    },
  },
  chartBox: {
    flex: '0 0 auto',
    width: 250,
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 24,
    },
  },
  tableBox: {
    flex: '1 1 auto',
    minWidth: 0,
  },
}), { name: 'PortfolioStructureChart', index: StylesIndexInjections.UI_MOLECULES });

